/**
 * Utility to clean and normalize Table of Contents (Daftar Isi) text.
 * Prevents HTML artifacts (e.g. `<p></p>`, `<p><br></p>`) from rich text editors
 * from showing up in plain textareas or database records.
 */
export const cleanTableOfContents = (value?: string | null): string => {
  if (!value) return '';
  const trimmed = value.trim();
  if (!trimmed) return '';

  // Check for common empty HTML tags produced by WYSIWYG editors
  const isEmptyHtml =
    /^(<p\b[^>]*>(<br\b[^>]*>|&nbsp;|\s)*<\/p>|<div\b[^>]*>(<br\b[^>]*>|&nbsp;|\s)*<\/div>|<br\s*\/?>|\s)+$/i.test(
      trimmed
    );
  if (isEmptyHtml || trimmed === '<p></p>' || trimmed === '<p><br></p>') {
    return '';
  }

  // If text contains HTML tags (e.g. from previous rich editor version), extract plain text properly
  if (/<[a-z][\s\S]*>/i.test(trimmed)) {
    const text = trimmed
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/p>/gi, '\n')
      .replace(/<\/div>/gi, '\n')
      .replace(/<\/li>/gi, '\n')
      .replace(/<li[^>]*>/gi, '• ')
      .replace(/<[^>]+>/g, '')
      .replace(/&nbsp;/gi, ' ')
      .replace(/&amp;/gi, '&')
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/&quot;/gi, '"')
      .replace(/&#39;/gi, "'")
      .replace(/\n{3,}/g, '\n\n')
      .trim();

    return text;
  }

  return trimmed;
};

export const hasValidTableOfContents = (value?: string | null): boolean => {
  return Boolean(cleanTableOfContents(value));
};
